import { render, staticRenderFns } from "./iconButton.vue?vue&type=template&id=64399b51&scoped=true&"
import script from "./iconButton.vue?vue&type=script&lang=js&"
export * from "./iconButton.vue?vue&type=script&lang=js&"
import style0 from "./iconButton.vue?vue&type=style&index=0&id=64399b51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64399b51",
  null
  
)

export default component.exports